/* eslint-disable @typescript-eslint/ban-types */
import { FocusZoneTabbableElements, GroupedList, IGroup, IProcessedStyleSet, mergeStyles } from '@fluentui/react';
import * as React from 'react';
import { AlchemySolutionModel, BcqrExperimentType, UserInfo } from '../../../web-legacy/models/apiModels';
import { SourceApps } from '../../../web-legacy/models/constants/constants';
import {
  ICommonThemedStyles,
  getCommonThemedClassNames,
  getCommonThemedStyles,
} from '../../../web-legacy/packages/contactUs/styles/commonStyles';
import { IContactUsStyles } from '../../../web-legacy/packages/contactUs/styles/contactUsStyles';
import { IStyledComponent } from '../../../web-legacy/packages/contactUs/styles/themesUI';
import { getHelpLogger } from '../../utils/getHelpLogger';
import { getBCQRTitle, getBcqrSolutions, getIsDifferentContentType } from '../../utils/selfHelpUtils';
import { getString } from '../../utils/stringLoader';
import { resultHeaderStyle } from '../styles/selfHelpStyles';
import { BcqrResultV2 } from './BcqrResultV2';

interface BcqrResultsProps {
  results: Array<AlchemySolutionModel>;
  runningInSoc: boolean;
  showRecommendedArticlesHeader: boolean;
  isThirdParty: boolean;
  articleOnClickHandler: (url: string) => {};
  sourceApp: SourceApps;
  bcqrExperimentType: BcqrExperimentType;
  correlationId: string;
  market: string;
  isInApp: boolean;
  isDarkTheme: boolean;
  isSignedIn: boolean;
  userInfo: UserInfo;
  isGetHelp: boolean;
}

type IBcqrResultsProps = BcqrResultsProps & IStyledComponent<IContactUsStyles>;

export const BcqrResultsV2 = (props: IBcqrResultsProps): JSX.Element => {
  const bcqrSolutionsTitle: string = getBCQRTitle();
  const commonThemedClassNames: IProcessedStyleSet<ICommonThemedStyles> = getCommonThemedClassNames(
    getCommonThemedStyles,
    { theme: props.theme, isDarkTheme: props.isDarkTheme }
  );

  const onRenderHeader = (): JSX.Element | null => {
    return (
      props.showRecommendedArticlesHeader && (
        <>
          <h2
            className={
              props.isGetHelp
                ? mergeStyles(resultHeaderStyle.root)
                : (props.sourceApp === SourceApps.SurfaceApp || props.sourceApp === SourceApps.SurfaceApp2)
                  ? commonThemedClassNames.h2
                  : commonThemedClassNames.header
            }
            style={{ margin: 0 }}
          >
            {bcqrSolutionsTitle}
          </h2>
        </>
      )
    );
  };

  const onRenderCell = (_nestingDepth?: number, item?: typeof BcqrResultV2): React.ReactNode => {
    return item ?? null;
  };

  let index = 1;
  const solutions: AlchemySolutionModel[] = getBcqrSolutions(props.bcqrExperimentType, props.results);
  getHelpLogger.logBCQRCoverage(solutions);
  const isDifferentContentType: boolean = getIsDifferentContentType(solutions);
  const results: JSX.Element[] = solutions.map(result => {
    return (
      <BcqrResultV2
        key={`${result.Title}-${index}`}
        alchemyResult={result}
        index={index++}
        isInApp={props.isInApp}
        theme={props.theme}
        styles={props.styles}
        articleOnClickHandler={props.articleOnClickHandler}
        bcqrExperimentType={props.bcqrExperimentType}
        correlationId={props.correlationId}
        isDifferentContentType={isDifferentContentType}
        contentType={result.ContentType}
      />
    );
  });

  const groups: IGroup[] = [];
  groups.push({
    key: 'RecommendedArticles',
    name: getString('GetHelp_MoreHelp'),
    startIndex: 0,
    count: results.length,
    isCollapsed: false,
  });

  return <GroupedList items={results} groupProps={{ onRenderHeader }} onRenderCell={onRenderCell} groups={groups}
    focusZoneProps={{ handleTabKey: FocusZoneTabbableElements.all }} />;
};
